import React from 'react'

import { Snackbar, SnackbarVariant } from '../Snackbar'

interface SnackbarContainerState {
  isOpen: boolean
  message: string | undefined
  variant: SnackbarVariant
}

class SnackbarContainer extends React.Component<{}, SnackbarContainerState> {
  constructor(props: {}) {
    super(props)

    this.state = {
      isOpen: false,
      message: undefined,
      variant: 'success',
    }
  }

  closeSnackbar = () => {
    this.setState({ isOpen: false })
  }

  showSnackbar = (message: string, variant: SnackbarVariant = 'success') => {
    this.setState({ isOpen: true, message, variant })
  }

  render() {
    const { isOpen, message, variant } = this.state
    return (
      <Snackbar
        isOpen={isOpen}
        handleClose={this.closeSnackbar}
        message={message}
        variant={variant}
      />
    )
  }
}

export { SnackbarContainer }
